import { IconTruck, Text } from '@vtex/admin-ui'
import {
  Rule,
  RuleActions,
  RuleContent,
  RuleDefaultActions,
  RuleDescription,
  RuleIcon,
  Tag,
} from 'ui'

import { FormattedMessage } from 'react-intl'
import { BenefitViewComponentBaseProps } from '.'
import { type BuyAndWinFreeShipping } from '../../../../../../typings'
import { ShippingVariantView } from '../../../../../ShippingVariantSelector/View'
import { messages } from '../messages'

export function FreeShippingBenefit(
  props: BenefitViewComponentBaseProps<BuyAndWinFreeShipping>
) {
  const { onEdit, onRemove, config } = props

  return (
    <Rule onClick={onEdit}>
      <RuleIcon>
        <IconTruck />
      </RuleIcon>

      <RuleDescription>
        <FormattedMessage
          {...messages.freeShipping.description}
          values={{
            b: (content) => <Text variant="body">{content}</Text>,
          }}
        />
      </RuleDescription>

      <RuleContent>
        <Tag>
          <FormattedMessage {...messages.freeShipping.free} />
        </Tag>
        <ShippingVariantView config={config} />
      </RuleContent>

      <RuleActions>
        <RuleDefaultActions onEdit={onEdit} onRemove={onRemove} />
      </RuleActions>
    </Rule>
  )
}
